module.exports = __webpack_public_path__ + "img/R6__0481.924bbd00.jpeg";